import { useParams, useSearchParams } from 'react-router-dom'
import SearchAgainButton from '../Components/SearchAgainButton'
import SearchResult from '../Components/SearchResult'

function Detail() {
  const { str } = useParams()
  const [searchParams, setSearchParams] = useSearchParams()
  let zip = searchParams.get('zip')
  let dt = searchParams.get('dt')

  return (
    <div>
      <div className="text-center">
        Shipment Tracking results for &ldquo;<strong>{str}&rdquo;</strong>.
      </div>
      <div className="text-center">
        <SearchAgainButton />
      </div>
      <div className="search-results">
        <SearchResult str={str} zip={zip} dt={dt} />
      </div>
    </div>
  )
}

export default Detail
